export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Instalación\",\n    \"label_other\": \"{{count}} instalaciones\"\n}\n"